import { cn } from '@sola/ark-core/utils/helpers.ts';
import type {
  ComponentBaseProps,
  FlexibleContentProps,
} from '@sola/schema/lib/schema.ts';

import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { HeaderGroup } from '../../../molecules/header-group/header-group.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';

export type BasicContentProps = FlexibleContentProps & ComponentBaseProps;

export const BasicContentSolo: React.FC<BasicContentProps> = ({
  seoLevel = 2,
  media: _media,
  quotation: _quotation,
  alt,
  inline,
  settings,
  ...props
}) => {
  const hasHeaderGroup = !alt;

  return (
    <section
      className={cn(
        'BasicContentSolo component component--container',
        settings?.themeOverride
          ? `${settings.themeOverride}-themeOverride`
          : '',
      )}
    >
      <div className="container container--inline-box">
        {hasHeaderGroup && (
          <HeaderGroup
            {...props}
            {...getBaseSizeProps(seoLevel, inline)}
            seoLevel={seoLevel}
          />
        )}
        {!hasHeaderGroup && (
          <div className="w-full max-w-md mx-auto">
            <FeatureBase
              {...props}
              {...getBaseSizeProps(seoLevel, inline)}
              seoLevel={seoLevel}
              variant={alt ? 'centered' : 'standard'}
              inline
            />
          </div>
        )}
      </div>
    </section>
  );
};
